import SloanTheme from "./js/sloan-theme.js";

require("./style/stylesheets/styles.scss");

var theme = new SloanTheme();
theme.init();
